/* unplugin-vue-components disabled */import { render } from "./virtualList.vue?vue&type=template&id=4dce42e9&scoped=true"
import script from "./virtualList.vue?vue&type=script&lang=js"
export * from "./virtualList.vue?vue&type=script&lang=js"

import "./virtualList.vue?vue&type=style&index=0&id=4dce42e9&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户南京邮电-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dce42e9"]])

export default __exports__